/* tslint:disable */
/* eslint-disable */
/**
 * NORA Api
 *  ## Headers  ### X-App-Version  Remember to include the `X-App-Version` header in every request. This will verify that the app version works with this API version. The API will return a `X-Minimum-App-Version` header as well including the minimum app version that is supported by this API. The contents of the header are is a JSON encoded DTO, `VersionHeaderDTO`. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const GeofenceRuleType = {
    CROSS_LINE: 'CROSS_LINE',
    NO_LOCATION: 'NO_LOCATION',
    IDLE_LOCATION: 'IDLE_LOCATION',
    ENTER: 'ENTER',
    EXIT: 'EXIT',
    INSIDE_AT: 'INSIDE_AT',
    OUTSIDE_AT: 'OUTSIDE_AT',
    CONVERGE: 'CONVERGE',
    DIVERGE: 'DIVERGE',
    DEVIATE: 'DEVIATE',
} as const;

export type GeofenceRuleType = typeof GeofenceRuleType[keyof typeof GeofenceRuleType];



